import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import renderRichText from '../../utils/renderRichText';

const IntroductionComponent = () => {
  const data = useStaticQuery(graphql`
    {
      intro: contentfulFacilitators(title: { eq: "Introduction" }) {
        title
        content {
          raw
        }
      }
    }
  `);

  const { intro } = data;
  const paragraph = JSON.parse(intro.content.raw);
  const title = intro.title;

  return (
    <div className="content">
      <div className="anchor">
        <section className="section has-background-info">
          <div className="container">
            <div>
              <h3 className="is-uppercase is-size-3 has-text-left">{title}</h3>
              {renderRichText(paragraph)}
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default IntroductionComponent;
